export function CatalogLoadMore({
  hasMore,
  loading,
  onLoadMore,
}: {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
}) {
  if (!hasMore) return null;
  return (
    <div className="catalog-load-more">
      <button
        className="p-button p-component"
        type="button"
        disabled={loading}
        aria-label={loading ? 'Loading more products' : 'Load more products'}
        onClick={onLoadMore}
      >
        {loading ? 'Loading…' : 'Load more'}
      </button>
    </div>
  );
}
